// eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
export interface SKU extends String {
  _id_: never;
}

export const sku = (s: string) => s as unknown as SKU;
